<div class="wrap">
	<div class="qo-flex-row-center-left qo-padding30 popup-header">
		<qo-icon
			[icon]="EQORebrandIcon.info_dark"
			[invertedScheme]="true"
			[scheme]="EQORebrandColor.SECONDARY"
			[color]="EQORebrandColor.SECONDARY"
			[size]="'sm'"
		></qo-icon>
		<h1 class="qo-margin-left20">
			{{'email_exists_title' | translate}}
		</h1>
	</div>
	<div class="qo-flex-col-center-left qo-padding30">
		<div class="qo-margin-bottom20">
			{{'email_exists_description' | translate}}
		</div>
	</div>
	<div class="qo-flex-col-top-left ">
		<div
			class="qo-flex-row-top-left qo-align-items-center product"
			*ngFor="let product of products"
			(click)="productClicked(product.url)"
		>
			<img [src]="product.icon">
			<h4 class="qo-margin-left30">{{product.name}}</h4>
		</div>
	</div>
	<div class="qo-flex-row-center-center qo-padding30">
		<button
			class="qo-button-standard qo-primary"
			(click)="dialog.closeAll()"
		>
			{{'OKAY.ALL' | translate}}
		</button>
	</div>
</div>
